// @flow

import styled from '@emotion/styled'
import type { SerializedStyles } from '@emotion/utils'
import * as React from 'react'

import { colors, media } from '@toggl/style'

export const Wrapper = styled<{
  children: React.Node,
  background?: string,
}>('div')`
  transform: skewY(10deg);
  background: ${(p) => p.background || colors.beige};
  overflow: hidden;
  position: relative;
  z-index: 1;

  > div {
    transform: skewY(-10deg);
  }
`

export const Content = styled<{ children: React.Node, id?: string }>('div')`
  margin: 0 auto;
  padding: 60px 30px;
  ${media.mq[1]} {
    max-width: 1200px;
    padding-top: 80px;
  }
  ${media.mq[2]} {
    padding-top: 120px;
  }
`
export const Background = ({
  children,
  background,
  ...props
}: React.ElementProps<typeof BackgroundStyled>): React.Element<
  typeof BackgroundStyled
> => (
  <BackgroundStyled {...props} background={background}>
    {children}
  </BackgroundStyled>
)

const BackgroundStyled = styled<{
  css?: SerializedStyles,
  className?: string,
  background?: string,
  bottomBg?: string,
  children: React.Node,
  topBg?: string,
}>('div')`
  background: ${(p) =>
    p.topBg && p.bottomBg
      ? `linear-gradient(to bottom, ${p.topBg} 50%, ${p.bottomBg} 50%) `
      : p.background || colors.beige};
  padding-bottom: 30px;
  padding-top: 30px;
  position: relative;

  ${media.mq[1]} {
    padding-bottom: 60px;
    padding-top: 60px;
  }

  ${media.mq[2]} {
    padding-bottom: 90px;
    padding-top: 90px;
  }
`
